// BrandNameStep.tsx — step 'brand-name' del onboarding.
// Qué hace: confirma/edita el nombre de marca detectado.
// Qué exporta: BrandNameStep.
// Quién lo usa: CreateWorkspaceModal.

import { Button } from '../../Button';
import { Input, InputWrapper } from '../../Input';

interface Props {
  brandName: string;
  setBrandName: (v: string) => void;
  confirmBrandName: () => void;
}

export function BrandNameStep({ brandName, setBrandName, confirmBrandName }: Props) {
  return (
    <>
      <InputWrapper style={{ marginBottom: 8 }}>
        <Input
          value={brandName}
          onChange={e => setBrandName(e.target.value)}
          placeholder="Brand name"
          autoFocus
        />
      </InputWrapper>
      <Button type="button" onClick={confirmBrandName} disabled={!brandName.trim()} style={{ width: '100%' }}>
        Confirm Name
      </Button>
    </>
  );
}
